/**
 * «Боты» — `GET /api/bots`: наши боты, их группы и что из групп дошло до «Чатов».
 * Спека `docs/specs/2026-10-21-bots-design.md`.
 */
import { apiFetch } from "@/lib/api";

export type Counts = { today: number; yesterday: number; week: number };

export type BotGroup = Counts & {
  id: string;
  title: string;
  kind: string;
  /** administrator / member / left / kicked; у MAX ещё absent (бота нет) и error. */
  status: string;
  status_label: string;
  members: number | null;
  /** Последнее сообщение, которое мы видели (Telegram — копия бота, MAX — «Чаты»). */
  last: string | null;
  /** MAX: самое свежее сообщение группы по API бота и последнее событие группы. */
  platform_last: string | null;
  platform_event: string | null;
  chat: (Counts & { id: number; last: string | null }) | null;
  problem: string | null;
};

export type Bot = {
  code: "tg" | "max" | "tg_client";
  title: string;
  username: string;
  channel: string;
  how: string;
  /** Telegram: режим приватности выключен — бот видит все сообщения групп. */
  read_all: boolean | null;
  error: string | null;
  kinds: { kind: string; label: string; n: number }[];
  private: { chats: number; messages: number; last: string | null };
  groups: BotGroup[];
};

export type BrowserGroup = {
  channel: string;
  peer: string;
  name: string;
  events: number;
  sends: number;
  last: string | null;
  users: string;
  accounts: string;
  why: string;
};

export type BotsReport = { today: string; days: number; bots: Bot[]; browser: BrowserGroup[] };

export function loadBots(): Promise<BotsReport> {
  return apiFetch<BotsReport>("/api/bots");
}
